<mat-form-field fxFlex="100">
  <mat-label>{{ label }}</mat-label>
  <mat-select *ngIf="!returnKey" [formControl]="control" [required]="required" (selectionChange)="onSelectionChange($event)" [multiple]="multiple">
    <mat-option *ngFor="let facility of facilities" [value]="facility.id">
      {{facility.address?.searchString}}
    </mat-option>
  </mat-select>
  <mat-select *ngIf="returnKey" [formControl]="control" [required]="required" (selectionChange)="onSelectionChange($event)" [multiple]="multiple">
    <mat-option *ngFor="let facility of facilities" [value]="facility">
      {{facility.address?.searchString}}
    </mat-option>
  </mat-select>
  <button *ngIf="((control.value !== null
    && multiple && control.value.hasOwnProperty('length')
    && control.value.length > 0) || (!multiple && control.value))
    && !required && !control.disabled"
          matSuffix
          mat-icon-button
          type="button"
          aria-label="Clear"
          (click)="clearValue(); $event.stopPropagation()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
</mat-form-field>
